import { useProductionStore } from "../../../stores/production";
import { getProductionByDepartementSuperviseur } from "../../../api/payments";
import { showToastError } from "../../../services/toast";

const SendChargeable = () => {
  const { formData, setProduction2, setIsLoading } = useProductionStore();

  const handleChargeableRequest = (chargeable: string | null) => {
    setIsLoading(true);
    setProduction2({});
    getProductionByDepartementSuperviseur(
      formData.date.split("-")[0],
      formData.idCustomerFile,
      chargeable || "",
    )
      .then((res) => {
        setProduction2(res.data);
      })
      .catch(() => {
        showToastError("Une erreur est survenue.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSend1 = () => handleChargeableRequest("true");
  const handleSend2 = () => handleChargeableRequest("false");
  const handleSend3 = () => handleChargeableRequest("");

  return (
    <div className="flex justify-start items-center">
      <button
        className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
        onClick={handleSend1}
      >
        Facturable
      </button>
      <button
        className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
        onClick={handleSend2}
      >
        Non Facturable
      </button>
      <button
        className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
        onClick={handleSend3}
      >
        Tout
      </button>
    </div>
  );
};

export default SendChargeable;
